import { observer } from "mobx-react";
import * as React from "react";
import { RoleGroups } from "../api";

import { ListUsers } from "../ui/molecules/list-users";
import { Section } from "../ui/atoms/section";
import { SelectionMode } from "@fluentui/react";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { articles } from "../help";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageUsers extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[articles.operatorTeamOperators, articles.downloadDocuments]}
                breadcrumb={store.i18n.t("page.users.title")}
            >
                <Section fill>
                    <ListUsers
                        selectionMode={SelectionMode.none}
                        roleGroup={RoleGroups.FLEET_USERS}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
